import React, { useState } from 'react';

export default function AdminBackendSection({ appId }) {
  const [expandedSections, setExpandedSections] = useState({
    trigger: false
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6 mb-6">
      <div className="mb-4">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <span>⚙️</span>
          <span>Backend Functionality</span>
        </h2>
        <p className="text-sm text-gray-500 mt-1">
          Backend services and job scheduling configuration
        </p>
      </div>

      <div className="space-y-4">
        {/* Trigger.dev Configuration */}
        <div className="border border-gray-200 rounded-lg">
          <button
            onClick={() => toggleSection('trigger')}
            className="w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
          >
            <h4 className="text-sm font-semibold text-gray-900">Trigger.dev</h4>
            <span className="text-gray-500 text-sm">
              {expandedSections.trigger ? '▼' : '▶'}
            </span>
          </button>
          {expandedSections.trigger && (
            <div className="p-4 pt-4 border-t border-gray-200 bg-gray-50">
              <div className="space-y-2 text-sm text-gray-700">
                <p className="text-xs text-gray-600 mb-3">
                  Trigger.dev is a platform for building and running background jobs, workflows, and scheduled tasks.
                </p>
                <div className="mt-3">
                  <a
                    href="https://cloud.trigger.dev/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-3 py-1.5 text-sm font-medium text-white bg-zapt-purple rounded-lg hover:bg-zapt-purple/90 transition-colors"
                  >
                    Open Trigger.dev Cloud →
                  </a>
                </div>
                <div className="mt-6 pt-4 border-t border-gray-300">
                  <h5 className="text-sm font-semibold text-gray-900 mb-3">Setup Instructions</h5>
                  <ol className="text-sm text-gray-700 space-y-2 list-decimal list-inside">
                    <li>Go to trigger.dev dashboard</li>
                    <li>Create new project</li>
                    <li>
                      Run this command in the CLI:{' '}
                      <code className="text-xs text-gray-800 font-mono bg-gray-100 px-2 py-1 rounded border border-gray-200">
                        npx trigger.dev@latest init
                      </code>
                    </li>
                    <li>Give the Trigger.dev Github app permission to see the repo</li>
                    <li>Connect GitHub to the trigger.dev project (set the "staging" environment to be connected to the "dev" git branch)</li>
                    <li>Set up an alert for errors or failed deployments</li>
                    <li>Add environment variables</li>
                    <li>
                      Manually do first deploy to staging:{' '}
                      <code className="text-xs text-gray-800 font-mono bg-gray-100 px-2 py-1 rounded border border-gray-200">
                        npx trigger.dev@latest deploy --env staging
                      </code>
                    </li>
                  </ol>
                </div>
                <div className="mt-6 pt-4 border-t border-gray-300">
                  <h5 className="text-sm font-semibold text-gray-900 mb-3">Using Neon database in Trigger.dev tasks</h5>
                  <p className="text-sm text-gray-700 mb-3">
                    Trigger.dev runs in a Node.js container (not an edge runtime), so you need the WebSocket driver instead of neon-http. Create <code className="text-xs font-mono bg-gray-100 px-1 rounded">trigger/_db.js</code> and install <code className="text-xs font-mono bg-gray-100 px-1 rounded">ws</code>.
                  </p>
                  <pre className="text-xs font-mono bg-gray-900 text-gray-100 p-4 rounded-lg overflow-x-auto">
{`import { Pool, neonConfig } from '@neondatabase/serverless';
import ws from 'ws';
import { drizzle } from 'drizzle-orm/neon-serverless';
import * as schema from '../drizzle/schema.js';

// Trigger.dev runs in a Node.js container (not an edge runtime), so the
// WebSocket driver is required instead of neon-http.
neonConfig.webSocketConstructor = ws;

const pool = new Pool({ connectionString: process.env.DATABASE_URL });
export const db = drizzle(pool, { schema });`}
                  </pre>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

